import * as React from 'react'

import Spinner from '~/client/src/shared/components/Spinner/Spinner'

export function PickerLoading(): React.ReactElement {
  return (
    <div className="tw:flex tw:flex-1 tw:min-h-0 tw:items-center tw:justify-center">
      <Spinner size="md" />
    </div>
  )
}
